
import './App.css';
import PageRouter from './PageRouter/PageRouter';
import 'primereact/resources/themes/lara-light-blue/theme.css'; 
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import "react-phone-input-2/lib/style.css";

function App() {
  return (
    <div >
     <PageRouter/>
    </div>
  );
}

export default App;
